/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The possible component output html static file referrer policies.
 * @export
 */
export type ComponentOutputHtmlStaticFilePolicy =
  | ComponentOutputHtmlStaticFilePolicyNoReferrer
  | ComponentOutputHtmlStaticFilePolicyNoReferrerWhenDowngrade
  | ComponentOutputHtmlStaticFilePolicyOrigin
  | ComponentOutputHtmlStaticFilePolicyOriginWhenCrossOrigin
  | ComponentOutputHtmlStaticFilePolicySameOrigin
  | ComponentOutputHtmlStaticFilePolicyStrictOrigin
  | ComponentOutputHtmlStaticFilePolicyStrictOriginWhenCrossOrigin
  | ComponentOutputHtmlStaticFilePolicyUnsafeUrl;

/**
 * The html static file no-referrer referrer policy type.
 * @export
 */
export type ComponentOutputHtmlStaticFilePolicyNoReferrer = typeof COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_NO_REFERRER;

/**
 * The html static file no-referrer-when-downgrade referrer policy type.
 * @export
 */
export type ComponentOutputHtmlStaticFilePolicyNoReferrerWhenDowngrade =
  typeof COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_NO_REFERRER_WHEN_DOWNGRADE;

/**
 * The html static file origin referrer policy type.
 * @export
 */
export type ComponentOutputHtmlStaticFilePolicyOrigin = typeof COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_ORIGIN;

/**
 * The html static file origin-when-cross-origin referrer policy type.
 * @export
 */
export type ComponentOutputHtmlStaticFilePolicyOriginWhenCrossOrigin =
  typeof COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_ORIGIN_WHEN_CROSS_ORIGIN;

/**
 * The html static file same-origin referrer policy type.
 * @export
 */
export type ComponentOutputHtmlStaticFilePolicySameOrigin = typeof COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_SAME_ORIGIN;

/**
 * The html static file strict-origin referrer policy type.
 * @export
 */
export type ComponentOutputHtmlStaticFilePolicyStrictOrigin =
  typeof COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_STRICT_ORIGIN;

/**
 * The html static file strict-origin-when-cross-origin referrer policy type.
 * @export
 */
export type ComponentOutputHtmlStaticFilePolicyStrictOriginWhenCrossOrigin =
  typeof COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_STRICT_ORIGIN_WHEN_CROSS_ORIGIN;

/**
 * The html static file unsafe-url referrer policy type.
 * @export
 */
export type ComponentOutputHtmlStaticFilePolicyUnsafeUrl = typeof COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_UNSAFE_URL;

/**
 * The html static file no-referrer referrer policy constant.
 * @export
 */
export const COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_NO_REFERRER = 'no-referrer';

/**
 * The html static file no-referrer-when-downgrade referrer policy constant.
 * @export
 */
export const COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_NO_REFERRER_WHEN_DOWNGRADE = 'no-referrer-when-downgrade';

/**
 * The html static file origin referrer policy constant.
 * @export
 */
export const COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_ORIGIN = 'origin';

/**
 * The html static file origin-when-cross-origin referrer policy constant.
 * @export
 */
export const COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_ORIGIN_WHEN_CROSS_ORIGIN = 'origin-when-cross-origin';

/**
 * The html static file same-origin referrer policy constant.
 * @export
 */
export const COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_SAME_ORIGIN = 'same-origin';

/**
 * The html static file strict-origin referrer policy constant.
 * @export
 */
export const COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_STRICT_ORIGIN = 'strict-origin';

/**
 * The html static file strict-origin-when-cross-origin referrer policy constant.
 * @export
 */
export const COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_STRICT_ORIGIN_WHEN_CROSS_ORIGIN =
  'strict-origin-when-cross-origin';

/**
 * The html static file unsafe-url referrer policy constant.
 * @export
 */
export const COMPONENT_OUTPUT_HTML_STATIC_FILE_POLICY_UNSAFE_URL = 'unsafe-url';
